<template>
 
 <modalEquipaments :equipmentsDTO=equipmentsWatchList :details=item></modalEquipaments>
 
</template>

<script>
import modalEquipaments from '@/common/components/modalEquipaments.vue';

export default {
  components: {
  modalEquipaments,
  },
  props: {
    itemSelected: {
      type: Object,
      default: () => ({})
    },
  },
  data (){
    return{
      equipmentsDTO : [
        {
          key: "hydros",
          title: "Hidrômetros",
          noDataMessage : "Não há hidrômetros cadastrados no setor"
        },
        {
          key: "pumps",
          title: "Bombas",
          noDataMessage : "Não há bombas cadastradas no setor"
        },
        {
          key: "sensors",
          title: "Sensores",
          noDataMessage : "Não há sensores cadastrados no setor"
        },
        {
          key:"valves",
          title: "Válvulas",
          noDataMessage : "Não há válvulas cadastradas no setor"

        },
      ],
    }
  
  },
  computed: {
    item() {
      return this.itemSelected;
    },
    equipmentsWatchList() {
      return  this.equipmentsDTO.map(itemEquipment => 
      { 
        itemEquipment.list = this.item[itemEquipment.key]
        return itemEquipment 
      })
      
    }
   
  },
  created (){
    // console.log(this.item)
  }
}
</script>

<style scoped>
  .wrapper-sector-equips {
    position: inherit !important;
    box-shadow: none !important;
    width: 100% !important;
    margin:0 !important;
    padding: 0 !important;

  }

  .wrapper-sector-equips > .content {
    margin: auto;
    width: 60% !important;
  }
  .selected{
    width: 100% !important;
  }
</style>
